module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljiro10yearslater-2@3x.jpg?caa2898c";